import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Tile, TilesPosition } from '@thro-types/users';

import { DrawerMode, LayoutState, TileDrawerState } from './types';

// The initial state of the ShoppingCart container
export const drawerInitialState: TileDrawerState = {
  open: false,
  tile: undefined,
  currentMode: DrawerMode.PREDEFINED,
  /**
   * Array for Tiles in PredefinedTilesContent which are Seleceted to add
   */
  selectedTilesToAdd: [],
  /**
   * Array for custom Tiles before Deletion
   */
  customTilesToDelete: []
};

export const layoutInitialState: LayoutState = {
  tilesPositions: []
};

const tileDrawerSlice = createSlice({
  name: 'tileDrawer',
  initialState: drawerInitialState,
  reducers: {
    close(state) {
      state.open = false;
      state.tile = undefined;
      state.selectedTilesToAdd = [];
      state.customTilesToDelete = [];
    },
    open(state) {
      state.open = true;
    },
    setTile(state, action: PayloadAction<Tile | undefined>) {
      state.tile = action.payload;
    },
    setCurrentMode(state, action: PayloadAction<DrawerMode>) {
      state.currentMode = action.payload;
    },
    addSelectedTileToAdd(state, action: PayloadAction<Tile>) {
      state.selectedTilesToAdd.push(action.payload);
    },
    removeSelectedTileToAdd(state, action: PayloadAction<number>) {
      state.selectedTilesToAdd = state.selectedTilesToAdd.filter(
        selectedTile => selectedTile.id !== action.payload
      );
    },
    addTileToCustomTilesToDelete(state, action: PayloadAction<Tile>) {
      state.customTilesToDelete.push(action.payload);
    },
    setCustomTilesToDelete(state, action: PayloadAction<Tile[]>) {
      state.customTilesToDelete = action.payload;
    },
    removeTileFromCustomTilesToDelete(state, action: PayloadAction<number>) {
      state.customTilesToDelete = state.customTilesToDelete.filter(
        selectedTile => selectedTile.id !== action.payload
      );
    }
  }
});

const layoutSlice = createSlice({
  name: 'layout',
  initialState: layoutInitialState,
  reducers: {
    setLayout(state, action: PayloadAction<TilesPosition[]>) {
      state.tilesPositions = action.payload;
    },
    removeTilePosition(state, action: PayloadAction<number>) {
      const index = state.tilesPositions.findIndex(tp => tp.tile.id === action.payload);
      if (index !== -1) {
        // Remove the tile
        state.tilesPositions.splice(index, 1);
        // Adjust positions of subsequent tiles
        for (let i = index; i < state.tilesPositions.length; i++) {
          state.tilesPositions[i].position--;
        }
      }
    },
    addTilePositionAtStart(state, action: PayloadAction<TilesPosition>) {
      // Add the new tile with position 0 at the start of the array
      state.tilesPositions.push({ ...action.payload, position: state.tilesPositions.length });
    }
  }
});

export const {
  actions: TileDrawerActions,
  reducer: tileDrawerReducer,
  name: drawerSliceKey
} = tileDrawerSlice;

export const { actions: LayoutActions, reducer: layoutReducer, name: layoutSliceKey } = layoutSlice;
